/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, {useContext, useState} from 'react';
import {Button, Button2, Footer, Header, Surface, Tab, Text} from 'components';
import {ButtonContainer, ChangePasswordContainer, Field, BaseWrapper} from './styles';
import {useHistory} from 'react-router-dom';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import {GlobalAuthContext} from 'store/context';
import {Form, Formik} from 'formik';
import {
  InputField,
  Section,
} from '@fitinsur/components';
import {Col, Row} from 'components/Grid';
import * as Yup from 'yup';
import {FitinsurAPI, MessageCenter} from 'utils';
import TopHeader from 'components/TopHeader/index';
import { LoaderContext } from '@fitinsur/contexts';

export default function ChangePasswordPage() {
  const history = useHistory();
  const authContext = useContext(GlobalAuthContext);
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const mc = new MessageCenter();

  const firstLoginState = authContext.firstLogin;
  const changePasswordLinkAnchor = (authContext.status == true && firstLoginState != true) ?? 'login';
  const changePasswordLinkText = (authContext.status == true && firstLoginState != true) ?? 'click here';
  const [changePasswordMessage, setChangePasswordMessage] = useState('Por favor informe as novas informações de conta');

  const [changePasswordState, setChangePasswordState] = useState(
    authContext.changedPassword
  );

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [disabled, setDisabled] = useState(true);

  return (
    <BaseWrapper>
      <TopHeader />
      <ChangePasswordContainer>
        <Row>
          <Col xs={12}>
            <Header
              title='Alteração de senha'
              subtitle={changePasswordMessage}
              linkText={changePasswordLinkText}
              linkAnchor={changePasswordLinkAnchor}
            />
          </Col>
        </Row>

        <Formik
          initialValues={{
            username: authContext.username || '',
            password: '',
            new_password: '',
            new_password_confirm: '',
          }}
          validationSchema={Yup.object({
            username: Yup.string()
              .email('Email Inválido')
              .required('* Campo obrigatório'),
            password: Yup.string().required('* Campo obrigatório'),
            new_password: Yup.string()
              .required('* Campo obrigatório')
              .test(
                'match',
                'A senha atual e nova não podem ser iguais',
                function (new_password) {
                  return new_password !== this.parent.password;
                }
              )
              .matches(
                /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\d]).*$/,
                "A senha deve ter ao menos 8 caracteres de comprimento e conter no mínimo: 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 dígito numérico."
              ),
            new_password_confirm: Yup.string()
              .required('* Campo obrigatório')
              .test(
                'match',
                'As senhas devem ser iguais',
                function (new_password_confirm) {
                  setDisabled(new_password_confirm !== this.parent.new_password);
                  return new_password_confirm == this.parent.new_password;
                }
              ),
          })}
          onSubmit={(values) => {
            updateIsLoadingStatus(true);
            const fitinsur = new FitinsurAPI();

            fitinsur
              .requestChangePassword(
                values.username,
                values.password,
                values.new_password
              )
              .then((response) => response.json())
              .then((data) => {
                authContext.login_response = data;
                if (data.ret_code === 200) {
                  authContext.status = false;
                  authContext.username = values.username;
                  authContext.person_product = data.ret_person_product;
                  authContext.user_region = data.ret_user_region;
                  authContext.firstLogin = false;
                  authContext.changedPassword = true;
                  if (data.ret_value.token) authContext.token = data.ret_value.token;
                  mc.success('Sua senha foi alterada com sucesso!');
                  history.push('login');

                  /* 
                  setChangePasswordMessage('Your password was changed sucessfully, to proceed with the login, please ');
                  setChangePasswordLinkText('click here');
                  setChangePasswordLinkAnchor('login');
                  setChangePasswordState(true);
                  setFirstLoginState(false);
                  */
                } else {
                  authContext.status = false;
                  authContext.username = values.username;
                  authContext.token = '';
                  authContext.person_product = [];
                  authContext.user_region = '';
                  authContext.firstLogin = false;
                  authContext.changedPassword = false;

                  const errorMsg = data.ret_code < 500 ?
                    data.ret_msg_details :
                    'Não foi possível processar a solicitação. Por favor verifique e tente novamente.';
                  
                  setChangePasswordMessage(errorMsg);
                  mc.error(errorMsg);
                  setChangePasswordState(false);
                }
                Header.subtitle = changePasswordMessage;
                updateIsLoadingStatus(false);
              })
              .catch(() => {
                authContext.status = false;
                authContext.username = values.username;
                authContext.token = '';
                authContext.person_product = [];
                authContext.user_region = '';
                authContext.firstLogin = false;
                authContext.changedPassword = false;

                setChangePasswordMessage('Não foi possível processar a solicitação. Por favor verifique e tente novamente.');
                mc.error('Não foi possível processar a solicitação. Por favor verifique e tente novamente.');
                setChangePasswordState(false);
                updateIsLoadingStatus(false);
              });
          }}
        >
          {(props) => (
            <Form>
                <Section>
                  <Row style={{ height: '100px'}}>
                    <Col xs={12}>
                      <Field
                        name='username'
                        label='E-mail:'
                        type='text'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        originalSize
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row style={{ height: '100px'}}>
                    <Col xs={12}>
                      <Field
                        name='password'
                        label='Senha Atual:'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        rightIcon = {showPassword ? "closedEye" : "openEye"}
                        rightIconClick = {() => setShowPassword(state => !state)}
                        type={showPassword ? "text" : "password"}
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row style={{ height: '100px'}}>
                    <Col xs={12}>
                      <Field
                        name='new_password'
                        label='Nova Senha:'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        rightIcon = {showNewPassword ? "closedEye" : "openEye"}
                        rightIconClick = {() => setShowNewPassword(state => !state)}
                        type={showNewPassword ? "text" : "password"}
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row style={{ height: '100px'}}>
                    <Col xs={12}>
                      <Field
                        name='new_password_confirm'
                        label='Confirme a Nova Senha:'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        rightIcon = {showConfirmPassword ? "closedEye" : "openEye"}
                        rightIconClick = {() => setShowConfirmPassword(state => !state)}
                        type={showConfirmPassword ? "text" : "password"}
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={12} style={{ position: 'static' }}>
                      <ButtonContainer>
                        <Button
                          secundary
                          type='submit'
                          id='btnChangePassword'
                          disabled={disabled}
                        >
                          Confirmar
                        </Button>
                      </ButtonContainer>
                    </Col>
                  </Row>
                </Section>
            </Form>
          )}
        </Formik>
      </ChangePasswordContainer>
      <Footer />
    </BaseWrapper>
  );
}
